import { NavLink, useParams, useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'




const homeUrl = process.env.REACT_APP_HOME_URL;

const ArticalDetails = () => {
  const { artical_slug } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const source = queryParams.get('source');
  const [loading, setLoading] = useState(false);
  const [articles, setArticles] = useState([]);
  const [article, setArticle] = useState([]);
  const [skeletoncard, setSkeletonCard] = useState(true);
  useEffect(() => {
    const fetchRSS = async () => {
      try {

      	let rssUrl = '';

				if (source === 'Coindesk') {
				  rssUrl = 'https://www.coindesk.com/arc/outboundfeeds/rss/';
				} else if (source === 'Cointelegraph') {
				  rssUrl = 'https://cointelegraph.com/rss/tag/bitcoin';
				} else if (source === 'Decrypt') {
				  rssUrl = 'https://decrypt.co/feed';
				} else if (source === 'Cryptoslate') {
				  rssUrl = 'https://cryptoslate.com/feed/';
				} else if (source === 'Bitcoin') {
				  rssUrl = 'https://news.bitcoin.com/feed/';
				}

        const proxyUrl = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(rssUrl)}`;

        const response = await fetch(proxyUrl);
        const data = await response.json();    

        setArticles(data.items);

        const matchedItem = data.items.map(item => {
				  const title = item.title.replace(/[^a-zA-Z0-9 ]/g, '');
				  if(title === artical_slug) {
				  	item.image = item.enclosure?.link || item.thumbnail || '';
				  	setArticle(item);
				  }
			});
		
        setLoading(false);
      } catch (err) {
        console.error('Error fetching RSS feed:', err);
        setLoading(false);
		setSkeletonCard(false);
      }
    };

    fetchRSS();
  }, []);


  const formatDate = (dateString) => {
	  const date = new Date(dateString);
	  return date.toLocaleString('en-US', {
	    year: 'numeric',
	    month: 'long',
	    day: 'numeric',
	    hour: 'numeric',
	    minute: '2-digit',
	    hour12: true
	  });
	};
	
if (!articles) return (
    <>
		<div className="skeleton-card">
			<div className="articaldetails_mainsec">
				<div className="container">
					<div className="row">
						<div className="col-sm-12 col-md-7 col-lg-8 col-xl-8">
							<div className="detailspage_contnt">
								<div className="breadcrumb_mainsec">
									<ul>
										<div className="skeleton skeleton-small-text"></div>
										<div className="skeleton skeleton-small-text"></div>
									</ul>
								</div>

								<div className="categorybox">
									<div className="skeleton skeleton-small-text"></div>
								</div>
								
								<div className="imgbox">
									<div className="skeleton skeleton-thumbnail"></div>
								</div>
								
								<div className="author_info">
									
									<div className="iconbox">
										<div className="skeleton skeleton-small-text"></div>
									</div>
								</div>
								
								<div className="contnt_box">
									<div className="skeleton skeleton-title"></div>
									<div className="skeleton skeleton-text"></div>
									<div className="skeleton skeleton-text"></div>
									<div className="skeleton skeleton-text"></div>
									<div className="skeleton skeleton-text"></div>
									<div className="skeleton skeleton-text"></div>
									<div className="skeleton skeleton-text"></div>
									<div className="skeleton skeleton-text"></div>
									<div className="skeleton skeleton-text"></div>
									<div className="skeleton skeleton-text"></div>
									<div className="skeleton skeleton-text"></div>
									<div className="skeleton skeleton-text"></div>
								</div>
								
								<div className="share_social_sec">
									<div className="skeleton skeleton-title"></div>
									<ul>
										<div className="skeleton skeleton-thumbnail"></div>
										<div className="skeleton skeleton-thumbnail"></div>
										<div className="skeleton skeleton-thumbnail"></div>
										<div className="skeleton skeleton-thumbnail"></div>
									</ul>
								</div>
							</div>
							
						</div>
						
						<div className="col-sm-12 col-md-5 col-lg-4 col-xl-4">
							<div className="artical_sidebar">
							
								<div className="latest_newsbox">
									<div className="title_box">
										<div className="skeleton skeleton-title"></div>
									</div>
									
									<div className="articals_sec">
										{articles.slice(0, 5).map((item, index) => (							
										<div className="articals_mainbox">
											<div className="articals_imgbox">
												<div className="skeleton skeleton-thumbnail"></div>
											</div>
											
											<div className="articals_contntbox">
												<div className="artical_contnt">
													<div className="skeleton skeleton-title"></div>
												</div>
												
												<div className="artical_info">
													<div className="skeleton skeleton-small-text"></div>
												</div>
											</div>
										</div>
										))}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</>
);

return (

<div className="articaldetails_wrapper">
	<div className="articaldetails_mainsec">
		<div className="container">
			<div className="row">
				<div className="col-sm-12 col-md-7 col-lg-8 col-xl-8">
					<div className="detailspage_contnt">
						<div className="breadcrumb_mainsec">
							<ul>
								<li><a href="#">Home</a></li>
								<li><span>{article.title}</span></li>
							</ul>
						</div>

						<div className="categorybox">
							<div className="categorytxt">
								<span>{source}</span>
							</div>
						</div>
						
						<div className="imgbox">
							<img alt={article.title} src={article.image} />
						</div>
						
						<div className="author_info">
							
							<div className="iconbox">
								<i className="far fa-calendar"></i>
								<span>{formatDate(article.pubDate)}</span>
							</div>
							{/*
							<div className="iconbox">
								<i className="fas fa-th-large"></i>
								<span>{article.categories && article.categories.join(', ')}</span>
							</div>
							*/}
						</div>
						
						<div className="contnt_box">
							<h2>{article.title}</h2>
							<div dangerouslySetInnerHTML={{ __html: article.content }} />
						</div>
						
						<div className="share_social_sec">
							<span className="titletxt">Share:</span>
							<ul>
								<li>
									<a
										  href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`${homeUrl}artical/${article.title}`)}`}
										  target="_blank"
										  rel="noopener noreferrer"
										><i className="fab fa-facebook-f"></i>
									</a>
								</li>
								<li>
									<a
									  href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(`${homeUrl}artical/${article.title}`)}`}
									  target="_blank"
									  rel="noopener noreferrer"
									><i className="fab fa-linkedin-in"></i>
									</a>
								</li>
								<li>
									<a
									  href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(`${homeUrl}artical/${article.title}`)}&text=${encodeURIComponent(article.title)}`}
									  target="_blank"
									  rel="noopener noreferrer"
									><i className="fab fa-twitter"></i>
									</a>
								</li>
								<li>
									<a
									  href={`https://t.me/share/url?url=${encodeURIComponent(`${homeUrl}artical/${article.title}`)}&text=${encodeURIComponent(article.title)}`}
									  target="_blank"
									  rel="noopener noreferrer"
									><i class="fab fa-telegram-plane"></i>
									</a>
								</li>
							</ul>
						</div>
					</div>
					
				</div>
				
				<div className="col-sm-12 col-md-5 col-lg-4 col-xl-4">
					<div className="artical_sidebar">
					
						<div className="latest_newsbox">
							<div className="title_box">
								<h2>Latest News</h2>
							</div>
							
							<div className="articals_sec">
								{articles.slice(0, 5).map((item, index) => (							
								<div className="articals_mainbox">
									<div className="articals_imgbox">
										<img alt={item.title} src={item.enclosure?.link || item.thumbnail || ''} />
									</div>
									
									<div className="articals_contntbox">
										<div className="artical_contnt">
											<h3><a href={`${homeUrl}artical/${item.title.replace(/[^a-zA-Z0-9 ]/g, '')}?source=${source}`}>{item.title}</a></h3>
										</div>
										
										<div className="artical_info">
											<span className="time_txt">{formatDate(item.pubDate)}</span>
										</div>
									</div>
								</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

);
};

export default ArticalDetails;